import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

/**
 * 卡片里的一组行（SelectRow / 任务行 / 作品行）。
 * 默认：灰底行、行间留缝；`ios:` 下是原生分组列表——透明行 + 发丝分隔线。
 */
export function RowList({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <div className={cn('flex flex-col gap-2 ios:gap-0 ios:divide-y ios:divide-border', className)}>
      {children}
    </div>
  );
}
